import React, { Suspense, useContext } from "react";
import { Grid, Modal, Box, CardActionArea } from "@mui/material";
import {
  DeploymentsByUsers,
  DeploymentsByPeriod,
  DeploymentsCalendarView,
  DeploymentsByStatus,
  DashboardStats,
} from "../components/charts";
import StatSkeleton from "../components/common/StatSkeleton";
import DottedTile from "../components/common/DottedTile";
import { grey } from "@mui/material/colors";

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 1000,
  bgcolor: 'background.paper',
  margin: 0,
  padding: 0,
  p: 4,
};

const Dashboard = () => {
  const [open, setOpen] = React.useState('');
  const handleClose = () => setOpen('');
  return (
    <div className="fragmentContainer">
      <Grid container rowSpacing={2} columnSpacing={{ xs: 1, sm: 2, md: 2 }}>
        <Suspense fallback={<StatSkeleton tiles={5} height={150} width={2.33} />}>
          <Grid size={{ xs: 2, sm: 4, md: 12, lg: 12 }}>
            <DashboardStats />
          </Grid>
        </Suspense>
        <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
          <DeploymentsCalendarView />
        </Grid>
        <Grid size={{ xs: 12, sm: 12, md: 3, lg: 3 }}>
          <DeploymentsByStatus setOpen={setOpen} />
        </Grid>
        <Grid size={{ xs: 12, sm: 12, md: 3, lg: 3 }}>
          <DeploymentsByUsers setOpen={setOpen} />
        </Grid>
        <Grid size={{ xs: 12, sm: 12, md: 6, lg: 6 }}>
          <DeploymentsByPeriod />`
        </Grid>
      </Grid>
      {open && <Modal
        open={open ? true : false}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          {open === 'user' && <DeploymentsByUsers popup setOpen={setOpen} />}
          {open === 'status' && <DeploymentsByStatus popup setOpen={setOpen} />}
        </Box>
      </Modal>}
    </div>
  );
};

export default Dashboard;
